module.exports = __webpack_public_path__ + "img/ext5.434715e7.png";